import { useForm } from 'react-hook-form';
import { showToast } from 'lib/toast';
import { pushConfigDraftsService } from 'lib/services/pushConfigDraftsService';
import { BackendError } from 'lib/types/entities';
import { FC } from 'react';

export type CreateTabModalProps = {
  readonly notificationId: string | null;
  readonly closeModal: () => void;
};

const { sendToUserPushConfigDraftsRequest } = pushConfigDraftsService();

export const TestPushModal: FC<CreateTabModalProps> = ({
  notificationId,
  closeModal,
}) => {
  const { register, formState, handleSubmit, setError } = useForm<{
    userId: string;
  }>({
    mode: 'onChange',
    defaultValues: {
      userId: '',
    },
  });

  const onSubmit = async (form: { userId: string }) => {
    if (!form.userId || !form.userId.trim()) {
      setError('userId', { message: 'Field is required' });

      return;
    }

    try {
      await sendToUserPushConfigDraftsRequest({
        user: `/users/${form.userId?.trim()}`,
        pushNotificationSettingDraft: `/push_notification_setting_drafts/${notificationId}`,
      });
      closeModal();
      showToast({
        type: 'success',
        title: 'Test notification has been successfully sent!',
        message: 'Notification has been sent successfully!',
      });
    } catch (e) {
      const errorResponse = e as {
        data?: BackendError;
        status: number;
      };

      if (errorResponse.data?.['hydra:description']) {
        if (
          errorResponse.data?.['hydra:description'].indexOf('/users/') !== -1
        ) {
          showToast({
            type: 'error',
            title: 'User not found',
          });

          return;
        }
        if (
          errorResponse.data?.['hydra:description'].indexOf(
            '/push_notification_setting_drafts/',
          ) !== -1
        ) {
          showToast({
            type: 'error',
            title: 'Notification not found',
          });

          return;
        }
      }
      showToast({
        type: 'error',
        title: 'Something went wrong with test notification!',
        message: 'Try again later.',
      });
    }
  };

  if (!notificationId) {
    return null;
  }

  return (
    <div className="flex flex-col p-10 rounded w-[100%] min-w-[700px]">
      <p className="text-2xl font-semibold pb-6">Send test push to user</p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col relative mb-8">
          <label htmlFor="userId" className="text-gray-400 pb-2 text-sm ">
            User ID
          </label>
          <input
            type="text"
            className="h-10 px-2 py-2 border-gray-200 border-solid border-2 rounded"
            {...register('userId', { required: 'Field is required' })}
            id="userId"
          />
          {formState.errors.userId && (
            <p className="text-red-500 text-xs pt-1">
              {formState.errors.userId.message}
            </p>
          )}
        </div>

        <p className="text-gray-800 text-right mb-2">
          Be sure to <b>Save</b> changes before sending a test push.
        </p>
      </form>
      <div className="flex justify-end gap-4 mt-4">
        <button
          type="button"
          className="text-blue-500 bg-white px-4 py-2 rounded"
          onClick={() => closeModal()}
        >
          Cancel
        </button>
        <button
          type="button"
          className="bg-blue-500 text-white px-10 py-2 rounded"
          onClick={handleSubmit(onSubmit)}
        >
          Send
        </button>
      </div>
    </div>
  );
};
